import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils.js';
import translate from './translate.js';
import translateZona from './translate_zona.js';


import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js';
import TableList from '../shared/TableList.js';

export default function RevisionsTable({ revisions }) {
  const CheckFeatures = useFeatureChecker()

  if (!revisions.length) {
    return <div className="not-found-table-items">No se encontraron cambios</div>
  }

  return (
    <TableList>
      <TableList.Header>
        <TableList.HeaderItem value="Fecha" />
        <TableList.HeaderItem value="Autor" />
        <TableList.HeaderItem value="Zona" />
        <TableList.HeaderItem value="Tipo de cambio" />
      </TableList.Header>

      <TableList.Body>
        {
          revisions.map(item => (
            <TableList.Row key={item.id}>
              <TableList.Column>
                <CheckFeatures feature='DETAIL_LOGS'>
                  <AllowedFeature>
                    <Link to={`/revisions/${item.id}`}>
                      {formatDate(item.created_at)}
                    </Link>
                  </AllowedFeature>
                  <DeniedFeature>
                    {formatDate(item.created_at)}
                  </DeniedFeature>
                </CheckFeatures>
              </TableList.Column>

              <TableList.Column>
                {item.author_id ?
                  <CheckFeatures feature="DETAIL_USER">
                    <AllowedFeature>
                      <Link to={"/members/" + item.author_id}> {item.author_name} </Link>
                    </AllowedFeature>
                    <DeniedFeature>
                      <span>{item.author_name}</span>
                    </DeniedFeature>
                  </CheckFeatures>
                  : 'No encontrado'}
              </TableList.Column>


              <TableList.Column value={translateZona(item.entity_type)} />
              <TableList.Column>
                {(() => {
                  switch (item.entity_type) {
                    case "UsersCompanies":
                      return (
                        <Link to={"/members/" + item.entity_data.user_id}>
                          {translate(item.action)}
                        </Link>

                      );
                    case "Comments":
                      return (<Link to={"/entries/" + item.entity_data.access_id}>
                        {translate(item.action)}
                      </Link>);
                    case "Door":
                      return (<Link to={"/doors/" + item.entity_data.id}>
                        {translate(item.action)}
                      </Link>);
                    case "DoorAccess":
                      return (<Link to={"/permissions/" + item.entity_data.id}>
                        {translate(item.action)}
                      </Link>);
                    case "Entry":
                      return (<Link to={"/entries/" + item.entity_data.id}>
                        {translate(item.action)}
                      </Link>);
                    case "Sensor":
                      return (<Link to={"/sensors/" + item.entity_data.id}>
                        {translate(item.action)}
                      </Link>);
                    case "UserIdentities":
                      return (
                        <Link to={"/members/" + item.entity_data.user_id + "/identities"}>
                          {translate(item.action)}
                        </Link>
                      );
                    case "Zone":
                      return (<Link to={"/zones/" + item.entity_data.id}>
                        {translate(item.action)}
                      </Link>);
                    default:
                      return translate(item.action);
                  }
                })()}
              </TableList.Column>
            </TableList.Row>
          ))
        }
      </TableList.Body>
    </TableList>
  )
}
